<template>
  <div class="box">
    <div class="list">
      <div style="text-align:center;font-size:20px;color:#24ba58;letter-spacing:0.2em;margin:50px;"
        v-show="testBankData.list&&testBankData.list.length==0&&!loading">
        暂无内容，请您尝试更换筛选条件!</div>

      <div class="item" v-for="(item,i) of testBankData.list" :key="item.course+item.id">
        <!-- 显示题目 -->
        <div id='topic-item-mark' class="item-topic">
          <span class="topic-title">{{i+1}}.难度：{{diffContent(item.diff)}} ({{item.diff}}分)</span>

          <!-- 展示内容 -->
          <div v-html="replaceImgSrc(item.title)" class="test-bank-topic">
          </div>

          <!-- 展示选项 -->
          <div class="option-box">
            <div v-if="item.optionA!=''" class="option-item">
              <span>A：</span>
              <div v-html="replaceImgSrc(item.optionA)"></div>
            </div>
            <div v-if="item.optionB!=''" class="option-item">
              <span>B：</span>
              <div v-html="replaceImgSrc(item.optionB)"></div>
            </div>
            <div v-if="item.optionC!=''" class="option-item">
              <span>C：</span>
              <div v-html="replaceImgSrc(item.optionC)"></div>
            </div>
            <div v-if="item.optionD!=''" class="option-item">
              <span>D：</span>
              <div v-html="replaceImgSrc(item.optionD)"></div>
            </div>
            <div v-if="item.optionE!=''" class="option-item">
              <span>E：</span>
              <div v-html="replaceImgSrc(item.optionE)"></div>
            </div>

          </div>

        </div>

        <!-- 显示操作 -->
        <div class="item-bottom">
          <!-- 收藏等操作 -->
          <div class="operation">
            <div class="operation-parse" @click="parseBtn(item.id)">
              <img src="~@/assets/img/testBank/jiexi.png" alt="">
              <span>解析</span>
              <i :ref="refName('parseIcon',item.id)" class="el-icon-arrow-down"></i>
            </div>

            <!-- 查看子题 -->
            <div v-if="item.isSub==1" @click="topicQuestionBtn(item.id)">
              <span>题目详情</span>
              <i :ref="refName('topicQuestion',item.id)" class="el-icon-arrow-down"></i>
            </div>

          </div>
        </div>

        <!-- 题目详情 -->
        <div v-if="item.isSub==1" v-show="showTopicIdList.indexOf(item.id)!=-1" class="topic-parse">
          <TopicParse :topicData='item' :topicQuestionId='topicQuestionId' />
        </div>

        <!-- 题目解析 -->
        <div v-show="showParseIdList.indexOf(item.id)!=-1" class="topic-parse">
          <TopicParse :topicImgUrl='topicImgUrl' :topicData='item' :activeMoveBoxId='activeMoveBoxId' />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import utils from "@/util/index";
import TopicParse from "./TopicParse";
import { questionPicPrefix } from "@/network/resourceRequest/api";

export default {
  name: "QuestionBankList",

  components: {
    TopicParse,
  },

  props: {
    testBankData: {
      type: Object,
      default: {},
    },

    //是否加载成功--------------------------------------------
    loading: {},
  },

  data() {
    return {
      //题目解析ID
      activeMoveBoxId: "",
      //展开的解析id列表
      showParseIdList: [],
      //题目详情id
      topicQuestionId: "",
      //展开题目详情id列表
      showTopicIdList: [],
      //图片地址前缀
      topicImgUrl: "",
    };
  },

  created() {
    //获取图片前缀
    questionPicPrefix().then((res) => {
      this.topicImgUrl = res.data.data;
    });
  },

  mounted() {
    this.initMathJax();
  },

  watch: {
    testBankData(newVal) {},
  },

  methods: {
    //解析按钮
    parseBtn(id) {
      if (!this.$store.state.isLogin) return utils.tipsLogin();
      if (this.showParseIdList.indexOf(id) != -1) {
        //不等于-1则说明解析显示并打开
        // 关闭
        this.showParseIdList.splice(this.showParseIdList.indexOf(id), 1);
        this.$refs[`parseIcon${id}`][0].style.transform = "rotate(0deg)";
      } else {
        //显示
        this.showParseIdList.push(id);
        this.$refs[`parseIcon${id}`][0].style.transform = "rotate(180deg)";
      }
      this.activeMoveBoxId = id;
    },

    //题目详情子题按钮
    topicQuestionBtn(id) {
      if (!this.$store.state.isLogin) return utils.tipsLogin();
      //不等于-1则说明解析显示并打开
      if (this.showTopicIdList.indexOf(id) != -1) {
        // 关闭
        this.showTopicIdList.splice(this.showTopicIdList.indexOf(id), 1);
        this.$refs[`topicQuestion${id}`][0].style.transform = "rotate(0deg)";
      } else {
        //显示
        this.showTopicIdList.push(id);
        this.$refs[`topicQuestion${id}`][0].style.transform = "rotate(180deg)";
      }
      this.topicQuestionId = id;
    },

    //返回ref
    refName(e, id) {
      return e + id;
    },

    //初始化题目的公式
    initMathJax() {
      setTimeout(function () {
        var div = document.querySelector(".test-bank-topic");
        MathJax.Hub.Config({
          extensions: ["tex2jax.js"],
          jax: ["input/TeX", "output/HTML-CSS"],
          tex2jax: {
            inlineMath: [["\\(", "\\)"]],
            displayMath: [
              ["$$", "$$"],
              ["\\[", "\\]"],
            ],
            processEscapes: true,
          },
          "HTML-CSS": {
            availableFonts: ["TeX"],
          },
        });
        //重新渲染mathjax代码
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
      }, 1000);

      $(function () {
        $(".test-bank-topic").each(function () {
          try {
            renderLatex(this);
          } catch (e) {}
        });
      });
    },

    //根据难度显示内容
    diffContent(diff) {
      switch (diff) {
        case 1:
          return "易";
          break;
        case 2:
          return "较易";
          break;
        case 3:
          return "中档";
          break;
        case 4:
          return "较难";
          break;
        case 5:
          return "难";
          break;
      }
    },

    //修改img前缀
    replaceImgSrc(title) {
      return title.replace(
        /src="\/tikuimages/g,
        `src="${this.topicImgUrl}/tikuimages`
      );
    },
  },
};
</script>

<style lang='less' scoped>
.box {
  width: 100%;
  height: 100%;

  user-select: none;

  .list {
    padding-top: 10px;
    width: 100%;
    height: 100%;

    .item {
      display: flex;

      // 解析时用到
      position: relative;

      margin-bottom: 25px;
      border-radius: 6px;
      width: 920px;

      font-size: 14px;
      line-height: 30px;

      color: #999;
      background: rgba(255, 255, 255, 1);

      box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.2);

      flex-direction: column;

      .item-topic {
        padding: 10px;

        .option-box {
          margin-top: 1em;

          .option-item {
            display: flex;
            margin: 0 1em;
          }
        }
      }

      .item-bottom {
        display: flex;

        height: 50px;

        background-color: #e9f8ee;

        align-items: center;
        justify-content: flex-start;

        .rate {
          display: flex;

          padding-left: 10px;

          align-items: center;
        }

        .operation {
          display: flex;

          .operation-parse {
            margin-right: 10px;
          }

          .el-icon-arrow-down {
            transform: rotate(0deg);
            transition: all 0.5s;
          }

          div {
            display: flex;

            margin-left: 10px;

            cursor: pointer;

            align-items: center;

            img {
              margin-right: 5px;
              width: 16px;
            }
          }

          .addTestBar {
            display: flex;

            border-radius: 5px;
            padding: 0 10px;
            height: 40px;

            color: #fff;
            background: #24ba58;

            align-items: center;

            img {
              border-radius: 50%;

              background-color: #fff;
            }
          }
        }
      }
    }

    .item:hover {
      box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
      transform: translateY(-1px);
    }
  }
}

// 题目公式样式
.test-bank-topic {
  .MathJye table {
    display: inline-block;
    float: none;
    zoom: 0;

    border-collapse: collapse;

    margin: 0;
    border: 0;
    padding: 0;

    font-size: inherit;
    font-weight: normal;
    font-style: normal;
    line-height: normal;
    text-align: center;
    vertical-align: middle;

    _font-size: 100%;
  }
  table.edittable {
    border-collapse: collapse;

    margin: 2px;

    text-align: center;
  }
  table.edittable td,
  table.edittable th {
    border: 1px solid #000;
    padding: 5px;

    line-height: 30px;
    vertical-align: middle;
    white-space: normal;
    word-break: break-all;
  }
  table.composition {
    border-collapse: collapse;

    margin: 2px;
    width: 98%;

    text-align: left;
  }
  table.composition td,
  table.composition th {
    border-width: 0;

    line-height: 30px;
    vertical-align: middle;
    white-space: normal;
    word-break: break-all;
  }
  table.composition2 {
    border-collapse: collapse;

    width: auto;
  }
  table.composition2 td,
  table.composition2 th {
    border: none;
    border-width: 0;

    line-height: 30px;
    text-align: left;
    vertical-align: middle;
    white-space: normal;
    word-break: break-all;
  }
}
</style>